import { AspectRatio, Box, Flex, Image } from "@chakra-ui/react";
import { PaddedOnMobile } from "@components/site/layout";
import { GetServerSidePropsContext } from "next";
import { getServerSession } from "next-auth";
import Head from "next/head";
import { useEffect, useState } from "react";
import { MdPlayCircleOutline } from "react-icons/md";
import ReactPlayer from "react-player";
import { createAuthOptions } from "./api/auth/[...nextauth]";

// TODO: check line heights first paraghraph and other
export const About = () => {
    const [isMounted, setIsMounted] = useState<boolean>();

    useEffect(() => {
        if (!isMounted) setIsMounted(true);
    }, []);

    if (!isMounted) return null;

    const maxWidth = { base: 450, md: 540 };
    return (
        <>
            <Head>
                <title key="title">Beyond Rarity - About</title>
            </Head>
            <PaddedOnMobile>
                <Flex direction="column" maxW={maxWidth} textStyle="site.text" gap="120px">
                    <Flex pos="relative" direction="column">
                        <Flex
                            pos="absolute"
                            bottom="-50px"
                            minW="100%"
                            w="100%"
                            justify="center"
                            align="center"
                        >
                            <Image
                                src="/images/About-Divider.png"
                                alt="Beyond Rarity - Divider"
                                minW={{ base: "95vw", md: "130%" }}
                                objectFit="fill"
                                my="-50%"
                                // border="1px solid white"
                            />
                        </Flex>
                        <Flex direction="column" gap={4}>
                            <Box textStyle="site.header">About</Box>
                            <Box>
                                Our mission is to make NFT valuation fast and easy for everyone.
                            </Box>
                            <Box>
                                With our <strong>BR</strong>ITE algorithm, ranking engine, and novel
                                UX, we enable anyone to valuate an entire collection instantly,
                                making pro-level information intuitive and insightful.
                            </Box>
                        </Flex>
                    </Flex>
                    <Flex direction="column" gap={4}>
                        <Box textStyle="site.siteText">Why Valuation?</Box>
                        <Box>
                            As busy NFT enthusiasts ourselves, we felt uneasy buying NFTs without
                            spending an inordinate amount of time researching multiple sources and
                            inferring the valuations. There’s no good integrated solution that’s
                            easy to use.
                        </Box>
                        <Box>
                            NFT markets are similar to the housing market in that they are both
                            inefficient because they have low price discovery, or in other words low
                            trading volume. To compound on this issue is the fact that the values of
                            NFTs are mostly subjective because there is no quantifiable basis to
                            anchor the valuation. We believe this is one factor that prevents many
                            of us from dipping our toes into the NFT pool because it’s not easy to
                            value an NFT.
                        </Box>
                        <Box>
                            We solve this problem by calculating the NFT metadata rarity and
                            integrating it with past sales data, which is a simple basis for
                            quantifying NFT valuation in a way that is easy to understand and apply.
                            We believe this can help bring more people into the NFT space.
                        </Box>
                    </Flex>
                    <Flex direction="column" gap={4}>
                        <Box textStyle="site.siteText">What about Creators?</Box>
                        <Box>
                            As creators ourselves, we’ve also created breakthrough ranking
                            customizations that puts control back into the hands of the makers, by
                            giving creators the ability to factor human sentiment into the way their
                            collections are ranked.
                        </Box>
                        <Box>
                            We view project creators as central to the NFT ecosystem and will
                            continue to support and innovate on their behalf.
                        </Box>
                    </Flex>
                    <Flex direction="column" gap={4}>
                        <Box textStyle="site.siteText">Why a Wall St Fam NFT?</Box>
                        <Box>
                            We envisioned creating pro-level analytics tools like you’d find on Wall
                            St but making them easy and accessible for everyone.
                        </Box>
                        <Box>
                            Most of us are busy enough balancing our school, career, life, family,
                            and passions. Which is why our Wall St Fam NFTs are all balancing a
                            unique combination of elements that symbolize those things.
                        </Box>
                        <Box>
                            Unless you’re a professional, why go about decoding all of the
                            complexities of advanced tools? Cuz ain’t nobody got time for that.
                        </Box>
                    </Flex>
                </Flex>
            </PaddedOnMobile>
            <PaddedOnMobile>
                <Box w="100%" h={maxWidth} maxH={maxWidth}>
                    <AspectRatio w="100%" h="100%" maxW="100%" ratio={16 / 9}>
                        <ReactPlayer
                            // ref={playerRef}
                            url="https://player.vimeo.com/video/745778087?h=9d70f537f4"
                            playIcon={<MdPlayCircleOutline size="20%" />}
                            controls={true}
                            // playing={true}
                            // muted={true}
                            // loop={true}
                            width="100%"
                            height="100%"
                            playsinline={true}
                        />
                    </AspectRatio>
                </Box>
            </PaddedOnMobile>
        </>
    );
};

export async function getServerSideProps(ctx: GetServerSidePropsContext) {
    return {
        props: {
            session: await getServerSession(ctx.req, ctx.res, createAuthOptions()),
        },
    };
}

export default About;
